export const STATUS = {
  open: { label: "Aperta", cls: "bg-accent/10 text-accent border-accent/30" },
  won: { label: "Vinta", cls: "bg-primary/10 text-primary border-primary/30" },
  lost: { label: "Persa", cls: "bg-destructive/10 text-destructive border-destructive/30" },
};

export function statusInfo(status) {
  return STATUS[status] || STATUS.open;
}

const DAY = 1000 * 60 * 60 * 24;

export function daysWaiting(offer) {
  if (!offer?.created_at) return 0;
  const created = new Date(offer.created_at).getTime();
  let end = Date.now();
  if (offer.status === "won" && offer.conversion_days != null) return offer.conversion_days;
  if (offer.status === "won" && offer.won_at) end = new Date(offer.won_at).getTime();
  if (offer.status === "lost" && offer.lost_at) end = new Date(offer.lost_at).getTime();
  return Math.max(0, Math.floor((end - created) / DAY));
}

export function historyLabel(type) {
  const map = {
    created: "Offerta creata",
    edited: "Offerta modificata",
    status_won: "Segnata come Vinta",
    status_lost: "Segnata come Persa",
    status_reopened: "Riaperta",
    contract_signed: "Contratto firmato caricato",
    sent_to_production: "Inviato alla produzione",
  };
  return map[type] || type;
}
